import { render, staticRenderFns } from "./article8.vue?vue&type=template&id=c95d4c90&scoped=true"
import script from "./article8.vue?vue&type=script&lang=js"
export * from "./article8.vue?vue&type=script&lang=js"
import style0 from "./article8.vue?vue&type=style&index=0&id=c95d4c90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d4c90",
  null
  
)

export default component.exports